import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getBenefitInfo, isExternalUrl } from 'src/utils/index';
import { BenefitsEnum } from 'src/common-types/index';
import { RootState } from 'src/store';
import { IBenefitsState } from 'src/store/slices/index';
import { SkeletonItems } from 'src/components/components/index';
import './style.scss';

interface IMapStateToProps {
  benefitsStore: IBenefitsState;
}

interface IProps extends IMapStateToProps {}

const ZERO = 0;

export class CruisesProgramListComponent extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { benefitsStore } = this.props;

    return (
      <div className="cruises-program-list">
        <h1 className="cruises-program-list__header">
          <FormattedMessage id="members.have.custom.getaway.programs" />
        </h1>
        {benefitsStore.benefits?.items ? (
          <div className="cruises-program-list__items-wrapper">
            {getBenefitInfo(benefitsStore.benefits, BenefitsEnum.Cruises)[ZERO].childItems.map(
              (item, index) =>
                isExternalUrl(item.url) ? (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                    key={`${index}${item.title}`}
                    className="cruises-program-list__item"
                  >
                    <div className="cruises-program-list__image-wrapper">
                      <img src={item.imageUrl} alt={item.title} />
                    </div>
                    <div className="cruises-program-list__info">
                      <p className="cruises-program-list__info-title">{item.title}</p>
                      <p className="cruises-program-list__info-content">{item.description}</p>
                    </div>
                  </a>
                ) : (
                  <Link
                    to={item.url}
                    key={`${index}${item.title}`}
                    className="cruises-program-list__item"
                  >
                    <div className="cruises-program-list__image-wrapper">
                      <img src={item.imageUrl} alt={item.title} />
                    </div>
                    <div className="cruises-program-list__info">
                      <p className="cruises-program-list__info-title">{item.title}</p>
                      <p className="cruises-program-list__info-content">{item.description}</p>
                    </div>
                  </Link>
                ),
            )}
          </div>
        ) : (
          <SkeletonItems />
        )}
        <div className="cruises-program-list__cruising-info-wrapper">
          <p className="cruises-program-list__cruising-info-header">
            <FormattedMessage id="cruising.makes.life" />
          </p>
          <div className="cruises-program-list__cruising-description-wrapper">
            <div className="cruises-program-list__cruising-description-info">
              <p className="cruises-program-list__cruising-description-title">
                <FormattedMessage id="members.only.rewards" />
              </p>
              <p className="cruises-program-list__cruising-description">
                <FormattedMessage id="your.membership.ensures.your.savings" />
              </p>
            </div>
            <p className="cruises-program-list__cruising-description cruising-description-bold">
              <FormattedMessage id="carnival.cruise.lines" />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    benefitsStore: state.benefitsStore,
  };
};

export const CruisesProgramList = connect(mapStateToProps, null)(CruisesProgramListComponent);
